<template>
  <div id="wrapper" >
    <div  style="overflow: auto;">
      <div id="outdate" style="display: none">您的授权书已失效，请联系绿羽重新取得授权！</div>
      <div :style="'background-image:url('+this.signData.bg_uri+'); width:100%;'" class="bk">

        <div class="first-content" style="margin-top: -80px">
          <div style="text-align: center;width:100%;">
            <img src="../assets/QRcode.png" style="width: 80%;">
          </div>
          <div class="main-content">
            <p style="font-size:16px;font-weight: bold;color: #000;text-align: center;">兹授予</p>
            <p style="font-size:16px;font-weight: bold;color: #000;text-align: center;">兹授予</p>

            <p style="text-align: center;font-size:18px;font-weight: bold">上海森洁环境工程有限公司</p>
            <p><span style="color: #43c50b;font-size:14px;">“绿羽地采暖基础材料体系”经销商</span></p>
            <p style="font-size:20px;font-weight: bold;margin-top: 20px">已合作</p>

          </div>
          <div style="text-align: center;width:100%;position:relative;">
            <img src="../assets/clock.png" style="width: 100%;">
            <p style="font-size:9px;position:absolute;top:29px;left:36px;text-align: center"><span
              class="wmpowertimeL" id="days">1572</span>
            </p>
            <p class="hours"><span class="wmpowertimeR" id="hours">22</span></p>
            <p style="font-size:9px;position:absolute;top:29px;right: 130px;"><span class="wmpowertimeR">:</span></p>
            <p class="minutes"><span class="wmpowertimeR" id="minutes">59</span></p>
            <p style="font-size:9px;position:absolute;top:29px;right:70px;"><span class="wmpowertimeR">:</span></p>
            <p class="seconds"><span class="wmpowertimeR" id="seconds">59</span></p>
          </div>
          <div class="second-content" style="margin-top: 90px; ">
            <p style="font-size:13px;font-weight:bold;color:#000;margin-right: 7px"><span>上海绿羽节能科技有限公司</span>
            </p>
            <p style="font-size:13px;color: #666;margin-right: 5px"><span>本授权的有效期截止至2019年12月31日</span></p>
          </div>
        </div>
        <img :src="this.signData.bg_uri" style="width: 100%;visibility:hidden;">
        <div>
          <p style="font-size: 30px;margin: 0 20px 0 20px;">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as Api from '../api/api'
  import Utils from '../api/Utils'

  export default {
    data() {
      return {
        id: '',
        signData: {}
      }
    },
    mounted() {
      this.id = this.$route.query.id;
      if (this.id && this.id !== "") {
        this.f_GetSign();
      } else {
        this.$alert("链接信息错误，请重新扫码!","提示信息",{type:"warning"});
      }
    },
    methods: {
      f_GetSign() {
        Api.GetSignById(this.id).then(res => {
          if (res.code === 1) {
            this.signData = res.data;
          }
        });
      },
      f_showStyle() {
        let style = "";
        if (this.signData && this.signData.bg_uri) {
          style = `background-image:url(${this.signData.bg_uri})`;
        }
        return style;
      }
    }
  }
</script>

<style>

  .bk {
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
  }

  .wmpowertimeL {
    color: #fff;
    font-size: 20px;
    font-family: Lato;
  }

  .wmpowertimeR {
    color: #333;
    font-weight: bold;
    font-size: 20px;
    font-family: Lato;
  }

  .main-content p {
    margin: 10px 0;
    line-height: normal;
    color: #000;
    font-size: 10px;
    text-align: center;
  }

  .first-content {
    position: absolute;
    padding: 40px
  }

  .second-content {
    text-align: right;
  }

  .second-content p {
    margin: 4px;
    line-height: normal;
    text-align: right;
  }

  .hours {
    font-size: 9px;
    position: absolute;
    top: 30px;
    right: 122px;
    text-align: center;
    width: 70px;
  }

  .minutes {
    font-size: 9px;
    position: absolute;
    top: 30px;
    right: 68px;
    text-align: center;
    width: 70px;
  }

  .seconds {
    font-size: 9px;
    position: absolute;
    top: 30px;
    right: 10px;
    text-align: center;
    width: 70px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Query.vue